import { z } from "zod";
const SyncStatusEntitySchema = z.object({
    id: z.string(),
    feedbackResponseId: z.string(),
    status: z.enum(["pending", "failed"]),
    attempts: z.number(),
    lastError: z.string().nullable(),
    createdAt: z.iso.datetime(),
});
// A feedback response that synced to ICIS successfully — shown as a recent-
// activity list, most-recently-synced first.
const SyncSuccessSchema = z.object({
    id: z.string(),
    feedbackResponseId: z.string(),
    icisId: z.string().nullable(),
    syncedAt: z.iso.datetime(),
});
export const SyncStatusResponseSchema = z.object({
    // Queue entries that have not synced — pending or failed.
    unsynced: z.array(SyncStatusEntitySchema),
    recentSuccesses: z.array(SyncSuccessSchema),
});
